module.exports = __webpack_public_path__ + "static/media/activity-bg.954f8b1c.png";